module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePage', {
    ref: "table",
    attrs: {
      "mainColumn": "name",
      "longColumn": "remark",
      "resource": _vm.resource,
      "title": "抄表详情",
      "label": "抄表详情",
      "labelName": "loginName",
      "operation": _vm.operation,
      "toolbar": _vm.toolbar,
      "operationWidth": 220,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "filterByAlways": _vm.filterByAlways,
      "columns": _vm.columns
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5f05c62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/MeterReading/Track/index.vue
// module id = 1804
// module chunks = 1